<template>
    <div>
        <!--HTML Fullpage : It's a textarea input with tinymce enabled with support for Doctype-->
        <label class="control-label">{{ pieceName }}</label>
        <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>

        <textarea class="step-tinymcearea form-control tinymcearea-fullpage" :name="'pieces[' + pieceIndex + '][content]'">{{  pieceContent }}</textarea>
        <div class="step-spacer"></div>
    </div>
</template>

<script>

    export default {
        name: 'html-fullpage-piece',
        data() {
            return {
            };
        },
        props: {
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            },
            pieceOptions: {
                type: Object,
                required:true
            }
        }
    }
</script>

<style lang="scss">

</style>